import React from "react";
import Tooltip from "@mui/material/Tooltip";
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
interface IScheduleIconProps {
    schedule: string
}
export default function ScheduleIcon({ schedule }: IScheduleIconProps) {

    return (
        <Tooltip title={schedule}>
            {schedule === 'Manual' ?
                <EditCalendarIcon sx={{ ml: 2.3 }} />
                :
                <EventRepeatIcon sx={{ ml: 2.3 }} />
            }
        </Tooltip>
    );
};
